import React from "react";
import Ticket from "./TicketRow";
import jwt_decode from "jwt-decode";

/**
 * Presentational row list for the maintenance request table. The parent owns
 * fetching (filters + pagination); this component only renders what it is
 * given and asks the parent to refresh after a row action mutates a ticket.
 */
export default function TicketList(props) {
  const tickets = Array.isArray(props.filteredTickets) ? props.filteredTickets : [];
  const notesCount = props.notesCount || {};

  const decode = jwt_decode(window.localStorage.getItem("accessToken"));

  const refresh = () => {
    if (typeof props.getTicket === "function") props.getTicket();
    else if (typeof props.searchTicket === "function") props.searchTicket();
  };

  let number = 0;
  let number1 = props.page > 1 ? (props.page - 1) * (props.pageSize || 10) : 0;

  return tickets.map((ticket) => {
    number++;
    return (
      <Ticket
        key={ticket._id}
        id={ticket._id}
        searchTicket={props.searchTicket}
        getTicket={refresh}
        number={number + number1}
        name={ticket.name}
        ticket={ticket}
        quotedVendorTickets={
          ticket.quotedVendorTickets?.length > 0
            ? ticket.quotedVendorTickets
            : []
        }
        email={ticket.email}
        phone={ticket.phone}
        assignedPropertyOwner={ticket?.propertyManagerId?.map(
          (v) =>
            `${v?.firstname ? v?.firstname : ""} ${
              v?.lastname ? v?.lastname : ""
            } ,`
        )}
        priority={ticket.priority}
        requestType={ticket.requestType}
        requestSubType={ticket.requestSubType}
        companyDomain={ticket.companyDomain}
        details={ticket.details}
        type={ticket.requestType}
        permission={ticket.permission}
        property={ticket.property}
        building={ticket.building}
        propertySignature={ticket.propertySignature}
        status={ticket.status}
        createdAt={ticket.createdAt}
        estimatedAmount={
          ticket.quotedVendorTickets?.length > 0
            ? ticket.quotedVendorTickets[0]?.estimatedAmount
            : ""
        }
        role={decode.role}
        assignVendor={ticket.assignVendor}
        startDate={
          ticket?.quotedVendorTickets?.length > 0
            ? ticket?.quotedVendorTickets[0].startDate
            : ticket.startDate
        }
        endDate={
          ticket?.quotedVendorTickets?.length > 0
            ? ticket?.quotedVendorTickets[0].endDate
            : ticket.endDate
        }
        startTime={
          ticket?.quotedVendorTickets?.length > 0
            ? ticket?.quotedVendorTickets[0].startTime
            : ticket.startTime
        }
        endTime={
          ticket?.quotedVendorTickets?.length > 0
            ? ticket?.quotedVendorTickets[0].estimatedETime
            : ticket.estimatedETime
        }
        estimatedEndDate={
          ticket?.quotedVendorTickets?.length > 0
            ? ticket?.quotedVendorTickets[0].estimatedEndDate
            : ticket.estimatedEndDate
        }
        notes={
          ticket?.quotedVendorTickets?.length > 0
            ? ticket?.quotedVendorTickets[0].notes
            : ticket.notes
        }
        isConfirmationSet={ticket.isConfirmationSet}
        suite={ticket.suite}
        isMovedToVendorPortal={ticket.isMovedToVendorPortal}
        confirmedQuote={ticket.confirmedQuote}
        assignedTo={ticket.assignedTo}
        assignSpecificVendors={ticket.assignSpecificVendors}
        internalStatus={ticket.internalStatus}
        rating={ticket.ratings}
        documents={ticket.documents}
        notesCount={notesCount}
        maintenanceWorkflow={ticket.maintenanceWorkflow || null}
      />
    );
  });
}